import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const SAVE_USER_TASK = 'SAVE_USER_TASK';


export const service = async (task) => {
  const options: object = {
    url:  "/Api/UserTasks/SaveUserTask" ,
    method: "POST",
    body: JSON.stringify(task),
    ...getDefaultOptions(),
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(SAVE_USER_TASK, service, mock);
